import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const FolderShimmer = ({ count = 5 }) => {
    return (
        <>
            {Array(count).fill(0).map((_, index) => (
                <ul key={index}>
                    <li className='mt-3'>
                        <Skeleton height={50} width={50} />
                        <b><Skeleton width={150} /></b>
                        <span><Skeleton width={130} /></span>
                    </li>
                    <li className='mt-3'>
                        <Skeleton height={50} width={50} />
                        <b><Skeleton width={150} /></b>
                        <span><Skeleton width={130} /></span>
                    </li>
                    <li className='mt-3'>
                        <Skeleton height={50} width={50} />
                        <b><Skeleton width={150} /></b>
                        <span><Skeleton width={130} /></span>
                    </li>
                    <li className='mt-3'>
                        <Skeleton height={50} width={50} />
                        <b><Skeleton width={150} /></b>
                        <span><Skeleton width={130} /></span>
                    </li>
                </ul>
            ))}
        </>
    )
}

export const FileShimmer = ({ count = 5 }) => {
    return (
        <>
            {Array(count).fill(0).map((_, index) => (
                <ul key={index}>
                    <li className='mt-3'>
                        <div className="image_wrap">
                            <Skeleton height={65} width={65} />
                            <div className="button_wrap">
                                <button
                                    className="me-1"
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "0px" }} />
                                </button>

                                <button
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "25px" }} />
                                </button>

                            </div>
                        </div>
                        <b><Skeleton height={20} width={180} /></b>
                        <span><Skeleton height={15} width={150} /></span>
                    </li>
                    <li className='mt-3'>
                        <div className="image_wrap">
                            <Skeleton height={65} width={65} />
                            <div className="button_wrap">
                                <button
                                    className="me-1"
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "0px" }} />
                                </button>

                                <button
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "25px" }} />
                                </button>

                            </div>
                        </div>
                        <b><Skeleton height={20} width={180} /></b>
                        <span><Skeleton height={15} width={150} /></span>
                    </li>
                    <li className='mt-3'>
                        <div className="image_wrap">
                            <Skeleton height={65} width={65} />
                            <div className="button_wrap">
                                <button
                                    className="me-1"
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "0px" }} />
                                </button>

                                <button
                                    type="button"
                                >
                                    <Skeleton circle height={20} width={20} style={{ position: "absolute", right: "25px" }} />
                                </button>

                            </div>
                        </div>
                        <b><Skeleton height={20} width={180} /></b>
                        <span><Skeleton height={15} width={150} /></span>
                    </li>
                </ul>
            ))}
        </>
    )
}